import React, { useState } from "react"
import { Link } from "gatsby"
import { motion, AnimatePresence } from "framer-motion"
// import { useLocation } from "@reach/router"

//data
import data from "../data/menu.json"

//transition
const transition = { duration: .8, ease: [0.8, -0.05, 0.01, 0.9] }

//variants
const parent = {
  animate: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2,
    },
  },
}

const titleSlideUp = {
  initial: { y: 400 },
  animate: { y: 0 },
}



const Menu = ({  menuState, setMenuState, x, y, setCursorHovered }) => {

  return (
    <>
      <AnimatePresence exitBeforeEnter>
        {menuState && (
          <>
            <motion.div
              initial={{ visibility: "hidden" }}
              animate={{ visibility: "visible" }}
              exit={{
                visibility: "hidden",
                opacity: 0,
              }}
              className="menu container"
            >

              <div className="menu-grid">
                <motion.div
                  variants={parent}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  className="menu-wrap"
                >
                  {data.cells.map(cells => (
                    <MenuLinks
                      key={cells.title}
                      title={cells.title}
                      url={cells.url}
                      x={x}
                      y={y}
                      setCursorHovered={setCursorHovered}
                      menuState={menuState}
                      setMenuState={setMenuState}
                    />
                  ))}
                </motion.div>
                
              </div>
            </motion.div>
            <MenuOverlay />
          </>
        )}
      </AnimatePresence>
    </>
  )
}

const MenuLinks = ({ title, url, x, y, setCursorHovered }) => {
  
  return (
    <AnimatePresence exitBeforeEnter>
      <motion.div className="menu-item">
        <Link to={url}>
          <h2 className="menu-item__wrap">
            <motion.div
              variants={titleSlideUp}
              transition={transition}
              className="menu-item__title"
              onMouseEnter={() => setCursorHovered(true)}
              onMouseLeave={() => setCursorHovered(false)}
            >
              {title}
            </motion.div>
          </h2>
        </Link>
      </motion.div>
    </AnimatePresence>
  )
}

const MenuOverlay = () => {
  const [overlayComplete, setOverlayComplete] = useState(false)
  return (
    <>
    <motion.div
        initial={{ height: 0 }}
        // animate={{ height: [0, window.innerHeight, 0 ] }}
        animate={{ height: [0, window.innerHeight], skewY: ["6deg", "0deg"] }}
        exit={{
          height: [window.innerHeight, 0],
          skewY: ["6deg", "0deg"],
          transition: {delay: 0.1}
        }}
        transition={{ duration: 1 }}
        // style={{ skewY: '2', originX: '100%', originY: '0%'  }}
        // style={{ skewY: "2deg", originX: "100", originY: "0" }}
        style={{ skewY: "2deg" }}
        className="menu-overlay menu-overlay__bottom"
      ></motion.div>
      <motion.div
        // style={{ background: overlayComplete ? "#e7e7de" : "#e7dee7" }}
        initial={{ height: 0 }}
        animate={{ height: [0, window.innerHeight], skewY: ["6deg", "0deg"] }}
        exit={{ height: [window.innerHeight, 0], skewY: ["6deg", "0deg"], transition: {delay: 0} }}
        transition={{ duration: 1, delay: 0.1 }}
        // style={{ skewY: "2deg", originX: "100", originY: "0" }}
        style={{ skewY: "2deg" }}
        className="menu-overlay menu-overlay__top"
        onAnimationComplete={() => {
          setOverlayComplete(!overlayComplete)
        }}
      ></motion.div>
    </>
  )
}

export default Menu
